import Swal from 'sweetalert2';
import api from '@/utils/api';
import LoadingComponent from '@/components/loading-component';
import * as Constants from '@/constants';

export default {
  name: 'ActionIcons',
  props: ['submission', 'fromDashboard'],
  components: {
    LoadingComponent
  },
  data() {
    return {
      showLoading: false
    };
  },
  methods: {
    editForm() {
      this.$router.push(`/edit/${this.submission.sessionId}`);
    },
    copyForm() {
      this.$router.push(`/copy/${this.submission.sessionId}`);
    },
    removeFromLocalStorage(id) {
      // get the submission array from local storage, parse as JSON
      const saved = JSON.parse(localStorage.getItem('submission-array')) || [];
      let filtered;
      // make sure the array isnt empty
      if (saved.length) {
        filtered = saved.filter((s) => {
          return s.sessionId !== id;
        });
        // add the filtered array back to localstorage
        localStorage.setItem('submission-array', JSON.stringify(filtered));
      }
    },
    deleteForm() {
      const id = this.submission.sessionId;
      Swal.fire(
        {
          type: 'warning',
          text: 'Are you sure you want to delete this Service Log?',
          showCancelButton: true
        })
        .then((response) => {
          // okay was clicked, delete the log
          if (response && response.value) {
            this.showLoading = true;
            api.delete(Constants.DELETE_NURSING_SESSION_URL(id))
              .then(() => {
                this.removeFromLocalStorage(id);
                this.showLoading = false;
                Swal.fire({
                  type: 'success',
                  text: 'Service Log has been successfully deleted.',
                  showConfirmButton: false,
                  onClose: () => {
                    this.$emit('service-log:deleted');
                  },
                  timer: 1000
                });
              })
              .catch((error) => {
                this.showLoading = false;
                this.errorMsg = error.message;
              });
          }
        });
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/service-log/action-icons/action-icons.js